export let search_tools_tab = "w2Q_E";
export default {search_tools_tab};